'use strict';

document.querySelectorAll('.sow-accordion').forEach(function (accordion) {
  var title = accordion.querySelector('.sow-accordion-title').innerHTML;
  accordion.querySelector('.sow-accordion-title').innerHTML = '<h3>' + title + '</h3>';
});